import React from 'react';
import styled, { css } from 'styled-components';

import constants from 'utils/constants'
import plusIconImg from 'images/plusicon.png';
import checkIcon from 'images/friend_check.png';

export default function FriendTaskListHeader({userData, onFriendRequest, onOpenBottomModal, onAcceptFriend}){
    const friendState = () => {
        if(userData.is_friend)
        {
            return (
                <RemoveFriendBtn onClick={onOpenBottomModal}>
                    <RemoveBtnTxt>친구</RemoveBtnTxt>
                </RemoveFriendBtn>
            )
        }
        else if(userData.is_friend_requested_received == true)
        {
            return (
                <OnRequestFriendBtn onClick={onAcceptFriend}>
                    <OnRequestBtnTxt>친구수락</OnRequestBtnTxt>
                </OnRequestFriendBtn>
            )
        }
        else if(!userData.is_friend_requested_received && userData.is_friend_requested)
        {
            return (
                <OnRequestFriendBtn onClick={onOpenBottomModal}>
                    <OnRequestBtnTxt>요청중</OnRequestBtnTxt>
                </OnRequestFriendBtn>
            )
        }
        else
        {
            return (
                <AddFriendBtn onClick={onFriendRequest}>
                    <AddButtonTxt>친구</AddButtonTxt>
                </AddFriendBtn>
            )
        }
    }

    return (
        <TaskHeaderWrapper>
            <UserInfoBlock>
                <UserProfileImgBlock>
                    <Image src={`${constants.imagePath}/user_profile_img/${userData.user.profile_img}`} />
                </UserProfileImgBlock>
                <UserInfo>
                    <UserName>{userData.user.nickname}</UserName>
                    {userData.user.achievement_goal ? (
                        <AchievementGoal>{userData.user.achievement_goal}</AchievementGoal>
                    ) : null}
                </UserInfo>
            </UserInfoBlock>
            <FriendStateBtnBlock>{friendState()}</FriendStateBtnBlock>
        </TaskHeaderWrapper>
    )
}

const Wrapper = styled.div`
    width: calc(100vh * (56 / 812));
    height: calc(100vh * (56 / 812));
    display: inline-block;
    margin-right: calc(100vw * (12 / 375));
    position:relative;
`;

const TaskHeaderWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(100vh*(23/812))  calc(100vw*(17/375));
`;

const UserInfoBlock = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

const UserProfileImgBlock = styled.div`
    width: calc(100vh*(56/812));
    height: calc(100vh*(56/812));
    border-radius: 100%;
    border: solid calc(100vw*(1/375)) #c6c6c6;
    margin-right:  calc(100vw*(12/375));    
    overflow:hidden;
    position: relative;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const UserInfo = styled.div``;

const UserName = styled.p`
    font-size: calc(100vw * (16 / 375));
    font-weight: bold;
    line-height: 1.5;
    color: #121212;
`;

const AchievementGoal = styled.p`
    width: auto;
    position: relative;
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    line-height: 1.5;
    color: #4e4e4e;
    z-index: 0; 
`;

const FriendStateBtnBlock = styled.div`
    display: block;
`;

const buttonStyle = css`
    width: calc(100vw*(67/375));
    height: calc(100vw*(27/375));
    border-radius: calc(100vw*(5/375));
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
`;

const AddFriendBtn = styled.button`
    ${buttonStyle}
    background-color: #ffffff;
    border: solid 1px #e6e6e6;
`;

const RemoveFriendBtn = styled.button`
    ${buttonStyle}
    background-color: #4e4e4e;
`;

const OnRequestFriendBtn = styled.button`
    ${buttonStyle}
    border: solid 1px #989898;
    background-color: #989898;
`;

const AcceptFriendBtn = styled.button`
    ${buttonStyle}
`;

const buttonTxtStyle = css`
    font-size: calc(100vw*(12/375));
    font-weight: 500;
`;

const AddButtonTxt = styled.p`
    ${buttonTxtStyle}
    color: #4e4e4e;
    &::before{
        content: "";
        display: inline-block;
        background-image: url(${plusIconImg});
        background-size: calc(100vw * (10 / 375)) calc(100vw* (10 / 375));
        background-repeat: no-repeat;
        width: calc(100vw * (10 / 375));
        height: calc(100vw* (10 / 375));
        margin-right: calc(100vw*(3/375));
    }
`;

const OnRequestBtnTxt = styled.p`
    ${buttonTxtStyle}
    color: #fff;
`;

const RemoveBtnTxt = styled.p`
    ${buttonTxtStyle}
    color: #fff;
    &::after{
        content: "";
        display: inline-block;
        background-image: url(${checkIcon});
        background-size: calc(100vw*(10.2/375)) calc(100vw*(7.9/375));
        background-repeat: no-repeat;
        width: calc(100vw*(10.2/375));
        height: calc(100vw*(7.9/375));
        margin-left: calc(100vw*(3/375));
    }
`;

